import hasPremiumTrainingUserUtil from 'modules/training/models/user/utils/has-premium'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import { createSelector } from 'reselect'

export const hasPremiumUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  (user) => hasPremiumTrainingUserUtil(user)
)
